module.exports = __webpack_public_path__ + "static/media/ic_next_arrow.518adf7e.svg";